import { render, staticRenderFns } from "./SubscriptionComponent.vue?vue&type=template&id=5fcdfe0b&scoped=true&"
import script from "./SubscriptionComponent.vue?vue&type=script&lang=js&"
export * from "./SubscriptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionComponent.vue?vue&type=style&index=0&id=5fcdfe0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcdfe0b",
  null
  
)

export default component.exports